import React from 'react';

const Footer = () => {
     return (
          <div className="bg-dark text-center text-white">
               <div className="p-5">
               <h2 className="text-info">Heaven Show</h2>
               <p className="text-warning">© tarequl islam</p>
               </div>
          </div>
     );
};

export default Footer;